import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const getUsersFromState = ({ users }: StoreState) => users;
export const getUsers = createSelector(
    getUsersFromState,
    ({ ids, entities }) => ids.map(i => entities?.[i])
);

export const isUserPatching = createSelector(
    getUsersFromState,
    ({ _isPatching }) => _isPatching
)


const getDatasets = ({users}: StoreState) => users.datasets; 
export const getUserDataset = createSelector(getDatasets, ({entities}) => entities);
export const getUserDatasetKeys = createSelector(getDatasets, ({ids}) => ids);
export const getUserSelectableList = createSelector(
    getDatasets,
    ({ entities, selectableList }) => selectableList.map(i => entities?.[i])
); 